// src/components/About.js
import React, { useEffect, useState } from "react";
import "../../css/AboutUs.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchSettings } from "../../redux/settingsSlice";
import Testimonial from "../Testimonial";
import founder from "../../images/about/founder.jpg";
import md from "../../images/about/md.jpg";
import pathway from "../../images/about/pathway.png";
import king from "../../images/about/king.png";
import trust from "../../images/about/trust.png";
import integrity from "../../images/about/integrity.png";
import visionbg from "../../images/about/visionbg.png";
import missionbg from "../../images/about/missionbg.png";
import vision from "../../images/about/vision.gif";
import mission from "../../images/about/mission.gif";
import family from "../../images/about/happy-family.png";
// import overlayshape from '../../images/about/overlayshape.png';
import wideproperty from "../../images/about/wide-selection-property.png";
import esupport from "../../images/about/end-to-end-support.png";
import excellence from "../../images/about/commitment-to-excellence.png";
import { Link } from "react-router-dom";
import axios from "axios";

const About = () => {
  const [plotCount, setPlotCount] = useState([]);
  const fetchPlotCount = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/getPlots`
      );

      if (response.data.status === true) {
        setPlotCount(response.data.plot_count);
      }
    } catch (error) {
      console.error("Error fetching blogs:", error);
    }
  };

  useEffect(() => {
    fetchPlotCount();
  }, []);

  return (
    <>
      <section className="about-section">
        <div className="abttagline">
          <h1>
            A plot of promise
            <br />
            where visions come to life
          </h1>
          <h5>सपने आपके, शुरुआत हमारी</h5>
        </div>

        <div className="statistics-area desk">
          <div className="row">
            <div className="col-md-4 col-6">
              <div className="statisbox">
                <h1>2500+</h1>

                <h5>Happy Clients</h5>
                <p>Over 2500 happy clients and counting.</p>
              </div>
            </div>

            {/* <div className="col-md-3 col-6">
              <div className="statisbox">
                <h1>7000+</h1>
                <h5>Successful Transaction</h5>
                <p>7000+ transactions, turning plots into dreams come true.</p>
              </div>
            </div> */}

            <div className="col-md-4 col-6">
             <div className="statisbox">
                <h1>10+</h1>
                <h5>Townships Listed</h5>
                <p>Explore over 10 townships available for sale.</p>
              </div>
            </div>

            <div className="col-md-4 col-6">
              <div className="statisbox">
                <h1>100%</h1>
                <h5>Customer Satisfaction</h5>
                <p>Turning buyers into delighted plot owners.</p>
              </div>
            </div>
          </div>
        </div>

        {/* <img src={overlayshapeover} alt='overlayshapeover' className='overlayshapeover' /> */}
        <img src={family} alt="family" className="family" />

        <div className="overlay"></div>
      </section>

      <section className="statistics-section sectionbotgap mob">
        <div className="row">
          <div className="col-md-4 col-6">
            <div className="statisbox">
              <h1>2500+</h1>

              <h5>Happy Clients</h5>
              <p>Over 2500 happy clients and counting.</p>
            </div>
          </div>

          {/* <div className="col-md-3 col-6">
            <div className="statisbox">
              <h1>7000+</h1>
              <h5>Successful Transaction</h5>
              <p>7000+ transactions, turning plots into dreams come true.</p>
            </div>
          </div> */}

          <div className="col-md-4 col-6">
            <div className="statisbox">
              <h1>10+</h1>
              <h5>Townships Listed</h5>
              <p>Explore over 10 townships available for sale.</p>
            </div>
          </div>

          <div className="col-md-4 col-6">
            <div className="statisbox">
              <h1>100%</h1>
              <h5>Customer Satisfaction</h5>
              <p>Turning buyers into delighted plot owners.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="visnmisn-section sectiontopgap sectionbotgap">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-12">
              <div className="vmbx">
                <div className="vm-mask-container">
                  <img src={vision} alt="vision" className="visn-topup" />
                  <img src={visionbg} alt="vision" className="target-image" />
                </div>
                <div className="vmdata">
                  <h2>Our Vision</h2>
                  <p>
                    Our vision is to make SiddhiAnanta a leading and trusted
                    name in the real estate industry, where every individual can
                    find their dream property and the best investment
                    opportunities. We envision a future characterized by
                    transparency, innovation, and long-term appreciation in
                    every aspect of real estate.
                  </p>
                  <p>
                    Our goal is not only to achieve business success but also to
                    contribute to sustainable development and prosperity across
                    all sectors of society. We are committed to fulfilling our
                    responsibility toward society and the environment through
                    every project we undertake.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-12">
              <div className="vmbx">
                <div className="vm-mask-container">
                  <img src={mission} alt="mission" className="visn-topup" />
                  <img src={missionbg} alt="mission" className="target-image" />
                </div>
                <div className="vmdata">
                  <h2>Our Mission</h2>
                  <p>
                    Our mission is to provide our clients with the best real
                    estate services that not only meet their current needs but
                    also lay a strong foundation for their future.
                  </p>
                  <p>
                    We offer excellent solutions in residential, commercial, and
                    investment properties, working with quality, transparency,
                    and integrity. Our aim is not just to facilitate property
                    transactions but to build long-term relationships with our
                    clients, ensuring their investments are safe and profitable.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="founder-section sectiontopgap sectionbotgap">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-12">
              <div className="trapezoid-left abt-mask-container">
                <img src={founder} alt="founder" className="target-image" />
              </div>
            </div>

            <div className="col-md-6 col-12 ownerdata">
              <div className="sectiontitle mb-3">
                {/* <p>Founder Message</p> */}
                <div className="titleunderline">
                  <svg
                    width="64"
                    height="3"
                    viewBox="0 0 64 3"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 1.5H62"
                      stroke="#F68633"
                      stroke-width="3"
                      stroke-linecap="round"
                    />
                  </svg>
                </div>
                <h1>Meet The Founder</h1>
                <h5>Rajendra Singh Chauhan</h5>
              </div>
              <div>
                <p>
                  Founder SiddhiAnanta was founded on a simple but powerful idea
                  – every person deserves a home that is not only beautiful and
                  safe, but also a reflection of their life dreams. When we
                  started this journey, my aim was not just to build buildings,
                  but to create a living experience for people that improves
                  their lives today and in the future. I firmly believe that the
                  property business is not just a business; it is a business of
                  trust.
                </p>
                <p>
                  Our customer satisfaction is our biggest asset. This is why we
                  have established ourselves as a reliable and responsible
                  company that believes in timely delivery, transparency, and
                  respecting customer wishes. At SiddhiAnanta, we build not just
                  for today, but for the future as well. We are committed to
                  breaking new ground with our values of trust, honesty, and the
                  highest quality.
                </p>
                <p>
                  I thank you from the bottom of my heart for being a part of
                  the SiddhiAnanta family. Without your trust, this journey
                  would not have been possible.
                </p>
              </div>
              <div className="btnbx">
                <Link to="/contactUs">
                  <button class="btn faci_button" type="button">
                    <span>Contact Us</span>
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="md-section sectiontopgap sectionbotgap">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-12 mob">
              <div className="trapezoid-right abt-mask-container">
                <img src={md} alt="md" className="target-image" />
              </div>
            </div>

            <div className="col-md-6 col-12 ownerdata">
              <div className="sectiontitle mb-3">
                {/* <p>Managing Director Message</p> */}
                <div className="titleunderline">
                  <svg
                    width="64"
                    height="3"
                    viewBox="0 0 64 3"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 1.5H62"
                      stroke="#F68633"
                      stroke-width="3"
                      stroke-linecap="round"
                    />
                  </svg>
                </div>
                <h1>Meet the Managing Director</h1>
                <h5>Khushbu Shekhawat</h5>
              </div>
              <div>
                <p>
                  I firmly believe that every customer's dream is priceless. For
                  us, real estate is not just a medium of business; it is a
                  business of trust. It is a strong relationship built on our
                  values and principles. Timely delivery, high quality, and
                  transparency are the pillars of our work. This belief is what
                  makes SiddhiAnanta a trusted name in the field of real estate.
                </p>
                <p>
                  SiddhiAnanta's journey has been one of continuous progress,
                  and we are committed to exploring new dimensions with our
                  principles in the future as well. Our vision for the future is
                  clear: with innovation, consistency, and excellence, we aim to
                  create a real estate brand that people can trust blindly. We
                  are grateful for your trust and support and are committed to
                  providing you with the best services as we continue this
                  journey together.
                </p>
                <p>
                  I thank you all for your support and trust in SiddhiAnanta's
                  journey. Your support, combined with our dedication, will
                  create a future where your dreams take real shape. We will
                  always stand by you on this journey to make your dreams come
                  true.
                </p>
              </div>

              <Link to="/contactUs">
                <button class="btn faci_button" type="button">
                  <span>Contact Us</span>
                </button>
              </Link>
            </div>

            <div className="col-md-6 col-12 desk">
              <div className="trapezoid-right abt-mask-container">
                <img src={md} alt="md" className="target-image" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pathway-section sectiontopgap sectionbotgap">
        <div className="container">
          <div className="sectiontitle mb-3">
            <div className="titleunderline">
              <svg
                width="64"
                height="3"
                viewBox="0 0 64 3"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 1.5H62"
                  stroke="#F68633"
                  stroke-width="3"
                  stroke-linecap="round"
                />
              </svg>
            </div>
            <h1>Your Pathway to Property Ownership</h1>
          </div>

          <div className="pathwaydata">
            <div className="abtstep abtstep1">
              <img src={king} alt="Customer-Centricity" />
              <h5>Customer-Centricity</h5>
              <p>
                Siddhiananta Group prioritizes the needs and satisfaction of its
                customers, ensuring their interests are always at the forefront
                of its operations.
              </p>
              <div className="abtstep1base abtstepbase"></div>
            </div>

            <div className="abtstep abtstep2">
              <img src={trust} alt="Transparency" />
              <h5>Transparency</h5>
              <p>
                The Siddhiananta Group is committed to building credibility and
                trust with its clients by having honest, open contact with them.
              </p>

              <div className="abtstep2base abtstepbase"></div>
            </div>

            <div className="abtstep abtstep3">
              <img src={integrity} alt="integrity" />
              <h5>Integrity</h5>
              <p>
                Siddhiananta Group upholds the highest ethical standards,
                ensuring fairness, honesty, and accountability in all its
                dealings.
              </p>
              <div className="abtstep3base abtstepbase"></div>
            </div>

            <div className="col-md-4 col-12 pathwayimg">
              <img src={pathway} className="img-fluid" />
              <div className="abtstep4base abtstepbase"></div>
            </div>
          </div>
        </div>
      </section>

      <section className="expri-section sectiontopgap sectionbotgap">
        <div className="container">
          <div className="sectiontitle mb-3">
            <div className="titleunderline">
              <svg
                width="64"
                height="3"
                viewBox="0 0 64 3"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 1.5H62"
                  stroke="#F68633"
                  stroke-width="3"
                  stroke-linecap="round"
                />
              </svg>
            </div>
            <h1>Experience Luxury, Choose Siddhi Ananta Group</h1>
          </div>

          <div className="expdata">
            <div className="row">
              <div className="col-md-4 col-12">
                <div className="expcard-out">
                  <img
                    src={wideproperty}
                    alt="wideproperty"
                    className="expcardimg"
                  />
                  <div className="expcard">
                    <h3>Wide Selection of Property</h3>
                    <p>
                      We provide plots for residential, business, and investment
                      purposes, meeting all needs and budgets.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-12">
                <div className="expcard-out expcard2">
                  <img src={esupport} alt="esupport" className="expcardimg" />
                  <div className="expcard">
                    <h3>End-to-End Support</h3>
                    <p>
                      Our dedicated team is here to answer your questions and
                      ensure a smooth transaction.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-12">
                <div className="expcard-out expcard2">
                  <img
                    src={excellence}
                    alt="excellence"
                    className="expcardimg"
                  />
                  <div className="expcard">
                    <h3>Commitment to Excellence</h3>
                    <p>
                      Count on our superior service, whether it's for personal
                      or investment purposes.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="abttest">
        <Testimonial />
      </div>
    </>
  );
};

export default About;
